<template>
  <div class="bg-white">
    <iframe
      ref="iframeRef"
      :src="url"
      class="w-full h-full border-none overflow-hidden"
    ></iframe>
  </div>
</template>

<script setup name="CustomerService">
const emit = defineEmits(["close"]);

import { ref, onMounted, nextTick } from "vue";
import { ChildRegister } from "/@/utils/iframeCall.js";
const getUrl = () => {
  const isDev = import.meta.env.DEV;
  // if (isDev) {
  // 	return 'http://localhost:5679';
  // }
  return window.globalConfig.AI_Chart_Url;
};

const url = getUrl();

const iframeRef = ref();

onMounted(() => {
  window.addEventListener("message", (event) => {
    if (event.data.type === "close") {
      emit("close");
    }
    if (event.data.type === "childIsReady") {
      ChildRegister.registerNotifyFunction();
    }
  });
});
</script>
<style scoped lang="scss">
.bg-white {
  background-color: #fff;
}
.w-full {
  width: 100%;
}
.h-full {
  height: 100%;
}
.border-none {
  border: none;
}
.overflow-hidden {
  overflow: hidden;
}
</style>
